import snakecaseKeys from 'snakecase-keys'
import axiosIns from '@/plugins/axios'

export default {
  getReservations({
    date = null, from = null, to = null, withDetails = null,
  } = {}) {
    return axiosIns.get('/waiter/reservations', {
      params: snakecaseKeys({
        date, from, to, withDetails,
      }),
    })
  },

  getReservation(id) {
    return axiosIns.get(`/waiter/reservations/${id}`)
  },

  createReservation(params) {
    return axiosIns.post('/waiter/reservations', snakecaseKeys({ reservation: params }, { deep: true }))
  },

  updateReservation(id, params) {
    return axiosIns.put(`/waiter/reservations/${id}`, snakecaseKeys({ reservation: params }, { deep: true }))
  },

  deleteReservation(id) {
    return axiosIns.delete(`/waiter/reservations/${id}`)
  },

  checkInReservation(id) {
    return axiosIns.put(`/waiter/reservations/${id}/check_in`)
  },

  checkBooking({
    date, startTime, endTime, hallId, tableNumber, excludeId = null,
  }) {
    return axiosIns.post('/waiter/reservations/check_booking', snakecaseKeys({
      date,
      startTime,
      endTime,
      excludeId,
      hallId,
      tableNumber,
    }))
  },
}
